import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.state.showBanner && _ctx.state.ad)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "ad",
          href: _ctx.state.ad.link,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickAd && _ctx.clickAd(...args)))
        }, [
          _createElementVNode("img", {
            class: "icon",
            src: _ctx.state.ad.icon
          }, null, 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.state.ad.name), 1)
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "tips" }, "广告", -1))
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.state.showBanner)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          class: "banner",
          href: _ctx.state.url,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickAd && _ctx.clickAd(...args)))
        }, [
          _createElementVNode("img", {
            class: "img",
            src: _ctx.state.banner
          }, null, 8, _hoisted_6),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "tips" }, "广告", -1))
        ], 8, _hoisted_5))
      : _createCommentVNode("", true)
  ], 64))
}